export default __webpack_public_path__ + "static/media/decision-making.f6e286e4.svg";